var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.65118 0.748562C7.78769 0.417145 8.21231 0.417146 8.34882 0.748562L9.95694 4.65269C10.1519 5.12609 10.5858 5.46419 11.1006 5.51411L15.149 5.90667C15.3055 5.92185 15.4271 6.02718 15.4781 6.19146C15.5295 6.35666 15.4922 6.53266 15.3603 6.65383L12.3058 9.45928C11.9287 9.80566 11.7692 10.3314 11.8766 10.8296L12.7705 14.9763C12.8124 15.1705 12.7353 15.331 12.6144 15.4228C12.4959 15.5128 12.3499 15.5296 12.2105 15.4431L8.71462 13.2728C8.27516 13 7.72484 13 7.28538 13.2728L3.78947 15.4431C3.65007 15.5296 3.50407 15.5128 3.38562 15.4228C3.26474 15.331 3.18765 15.1705 3.22951 14.9763L4.12343 10.8296C4.23083 10.3314 4.07134 9.80565 3.69421 9.45928L0.639695 6.65383C0.507758 6.53266 0.470547 6.35666 0.521888 6.19146C0.572942 6.02718 0.694508 5.92185 0.851041 5.90667L4.89943 5.51411C5.41418 5.46419 5.84807 5.12609 6.04306 4.65269L7.65118 0.748562Z",
    stroke: "#747085"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.1ae67fed7f12e8b9518ae65318e45553.svg";
export { ForwardRef as ReactComponent };